// src/components/HomePage.js
import React, { useState, useEffect } from 'react';
import { Box, Flex, Button, Heading, Text, Image, Container, Divider, VStack, SimpleGrid, Icon, Stat, StatLabel, StatNumber, StatHelpText,
    AspectRatio,
 } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { ViewIcon, StarIcon } from '@chakra-ui/icons'; 
import axios from 'axios';
import founderImage from '../assets/founder.png';
import backgroundImage from '../assets/jagdish-ji-temple.jpg';

const API_BASE_URL = 'https://api-amg2dwk5ga-uc.a.run.app';

const HomePage = () => {
    const [memberCount, setMemberCount] = useState(0);

    useEffect(() => {
    const fetchMemberCount = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/stats/approved_members_count`);
        if (response.data && response.data.approved_member_count) {
          setMemberCount(response.data.approved_member_count);
        }
      } catch (error) {
        console.error("Could not fetch member count:", error);
      }
    };

    fetchMemberCount();
  }, []);
  return (
    <Box>
        <Box
        bgImage={`url(${backgroundImage})`}
        bgPosition="center"
        bgRepeat="no-repeat"
        bgSize="cover"
        h="60vh" // Adjust the height as needed
        display="flex"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        p={8}
    >
        <VStack spacing={4} color="white" // Set text color to white for better visibility on the background
        >
            <Heading as="h1" size="2xl">Bagda Samaj Pragati Path</Heading>
            <Text fontSize="xl">Connecting our community, preserving our culture.</Text>
            <Button as={Link} to="/register" colorScheme="brand" size="lg" mt={6}>
                Join Us Today
            </Button>
        </VStack>
    </Box>
    <Container maxW="container.lg" py={12} textAlign="center">
          <Stat
            p={6}
            borderWidth="1px"
            borderRadius="lg"
            boxShadow="md"
            display="inline-block"
          >
              <StatLabel fontSize="xl" color="gray.500">Registered Users</StatLabel>
              <StatNumber fontSize="5xl" fontWeight="bold" color="brand.600">
                  {memberCount}
              </StatNumber>
              <StatHelpText>Registered Members in Our Community</StatHelpText>
          </Stat>
      </Container>
      <Box as="section" py={20}>
        <Container maxW="container.lg">
          <Heading as="h2" size="xl" textAlign="center" mb={10}>
            Our Community Initiative
          </Heading>
          <AspectRatio ratio={16 / 9} maxW="800px" mx="auto" boxShadow="2xl" borderRadius="lg" overflow="hidden">
            <iframe
              title="Community Video"
              src="https://www.youtube.com/embed/0rFnb_U4LSs"
              allowFullScreen
            />
          </AspectRatio>
        </Container>
      </Box>
        <Container maxW="container.lg" py={20}>
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10}>
                {/* Our Mission */}
                <VStack align="center" textAlign="justify" spacing={4}>
                    <Icon as={StarIcon} w={10} h={10} color="brand.500" />
                    <Heading as="h2" size="lg">Our Mission</Heading>
                    <Text fontSize="md" color="gray.600">
                        To empower and integrate the Bagda community brothers not only in India but all over the world for cultural, social and business networking along with economic development of the Bagda community brothers.
                    </Text>
                </VStack>

                {/* Our Vision */}
                <VStack align="center" textAlign="justify" spacing={4}>
                    <Icon as={ViewIcon} w={10} h={10} color="brand.500" />
                    <Heading as="h2" size="lg">Our Vision</Heading>
                    <Text fontSize="md" color="gray.600">
                        Bagda Samaj Pragati Path (BSPP) is an organization formed for the benefit of the Bagda community. Established with the objective of promoting cultural, social, economic and business harmony among its members, BSPP strives to unite the Bagda community brothers not only across India but also across the world and strengthen the collective identity and recognition of the Bagda community on the global platform.
Our goal is to become a strong organization of the Bagda community which establishes and advances effective business networking and social, cultural prosperity and networking.
                    </Text>
                </VStack>
            </SimpleGrid>
        </Container>
        <Container maxW="container.lg" py={20}>
            <Heading as="h2" size="xl" textAlign="center" mb={12}>About the Founder</Heading>
            <Flex direction={{ base: 'column', md: 'row' }} align="center" justify="center">
                <Box flexShrink={0} mr={{ base: 0, md: 10 }} mb={{ base: 6, md: 0 }}>
                    <Image borderRadius="full" boxSize="200px" src={founderImage} alt="Founder's Name" objectFit="cover" boxShadow="lg" />
                </Box>
                <Box>
                    <VStack spacing={1} align="flex-start" mb={4}>
                        <Heading as="h3" size="lg">
                            Chandra Prakash Sharma
                        </Heading>
                        <Text fontSize="md" color="brand.600" fontWeight="bold">
                            Founding member of Bagda Social Group (BSG)
                        </Text>
                    </VStack>
                    <Text fontSize="lg" color="gray.700">
                        Hailing from the heart of our community, our founder envisioned a digital space where every member could connect, support one another, and thrive together...
                    </Text>
                </Box>
            </Flex>
        </Container>
        <Divider />
    </Box>
)};

export default HomePage;